import React, { FC } from 'react'

import { Modal } from 'antd'
import QRCode from 'react-qr-code'

interface QRModalProps {
	title: string
	visible: boolean
	link: string
	onClose: () => void
}

const QRModal: FC<QRModalProps> = ({ title, visible, link, onClose }) => {
	return (
		<Modal
			title={title}
			open={visible}
			onCancel={onClose}
			okText="知道了"
			onOk={onClose}
			cancelButtonProps={{ style: { display: 'none' } }}
			centered
		>
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<QRCode value={link} />
			</div>
		</Modal>
	)
}

export default QRModal
